import { Tooltip, useIsXOverflow } from '@equifinance/shared';
import { useRef } from 'react';
import styled from 'styled-components';

const LongCellConatiner = styled.div`
  max-width: 100%;
`;

const LongCellContent = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default function LongContentCell(content?: string, id?: string) {
  const ref = useRef<HTMLDivElement>(null);
  const isTruncated = useIsXOverflow(ref);

  return (
    <LongCellConatiner id={`long-cell-${id}`}>
      <LongCellContent ref={ref}>
        {content}
      </LongCellContent>
      {content && isTruncated && (
        <Tooltip
          id={`long-cell-${id}`}
          html={content}
          place="top"
        />
      )}
    </LongCellConatiner>
  );
}
